<template>
    <div>
        <div class="mb-1">
            <label v-if="label" :for="inputId" class="font-bold">{{ label }}</label>
        </div>

        <div class="drop-area border border-gray-400 rounded mb-2">
            <ul v-if="files.length > 0" class="p-4">
                <li v-for="file in files" :key="file.id" class="flex items-baseline mb-1">
                    <span class="">{{ file.name }}</span>
                    <span class="text-xs text-gray-600 ml-2">{{ file.size | formatSize }}</span>
                    <div class="itatlic ml-4 text-xs">
                        <a href="#" @click.prevent="remove(file)">Remove</a>
                    </div>
                </li>
            </ul>
            <div v-else class="flex flex-col justify-around h-16 text-center">
                <div
                    v-show="$refs.uploadzone && $refs.uploadzone.dropActive"
                    class="bg-gray-200 h-full text-gray-700 flex flex-col justify-around"
                >
                    Drop here to upload
                </div>
                <div v-show="$refs.uploadzone && !$refs.uploadzone.dropActive" class=" text-gray-500">
                    Drag and drop attachments here
                </div>
            </div>
        </div>

        <div>
            <p class="mb-2 text-gray-500 flex-1 italic text-sm">{{ helpText }}</p>
            <div class="flex items-center space-x-4">
                <file-upload
                    ref="uploadzone"
                    v-model="files"
                    class="btn btn-primary btn-sm hover:cursor-pointer"
                    :multiple="true"
                    :maximum="5"
                    :size="1024 * 1024"
                    extensions="pdf,png,jpg,jpeg,doc,docx,xls,xlsx"
                    accept="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document
    ,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
    ,image/png,image/jpeg,application/pdf"
                    drop=".drop-area"
                    :drop-directory="true"
                    @input-filter="inputFilter"
                >
                    <i class="fa fa-plus"></i> Add Attachments
                </file-upload>
                <slot name="submitButton"></slot>
            </div>
        </div>
    </div>
</template>

<script>
const VueUploadComponent = () => import(/* webpackChunkName: "lazy-loaded/vue-upload-component" */ 'vue-upload-component');
import FormInputsMixin from './form_inputs_mixin';

export default {
    components: {
        'file-upload': VueUploadComponent
    },

    mixins: [FormInputsMixin],

    props: {
        helpText: {
            type: String,
            default: null
        },
        type: {
            type: String,
            default: null
        },
        maxFileSize: {
            type: Number,
            default: 1
        }
    },

    data() {
        return {
            files: []
        };
    },

    computed: {
        maxFileSizeInBytes() {
            return this.maxFileSize * 1048576;
        }
    },

    mounted() {},

    methods: {
        inputFilter: function(newFile, oldFile, prevent) {
            if (newFile) {
                if (newFile.size > this.maxFileSizeInBytes) {
                    flash.error({ message: `File size cannot be more than ${this.maxFileSize}MB.` });
                    return prevent();
                }
            }
        },

        remove(file) {
            this.$refs.uploadzone.remove(file);
        }
    }
};
</script>
